// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import SpinnerButton from 'shared/components/SpinnerButton';

class ReferralExhauster extends Component {
  constructor(props, context) {
    super(props, context);
    this.exhaustReferral = this.exhaustReferral.bind(this);
  }

  exhaustReferral(formValues) {
    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/exhaustions`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully marked this referral as exhausted',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent form="referralExhaust" onSubmit={this.exhaustReferral} />
    );
  }
}

ReferralExhauster.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>Exhaust Referral</h3>
    </div>
    <div className="modal-body" style={{ width: '600px' }}>
      Are you sure you wish to mark this referral as exhausted?
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Continue
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default ReferralExhauster;
